var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-center align-items-center" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Ver detalle",
                  expression: "'Ver detalle'"
                }
              ]
            },
            [
              _c(
                "b-button",
                {
                  staticClass: "btn-icon rounded-circle p-3",
                  attrs: {
                    variant: "secondary",
                    size: "sm",
                    "data-cy": "details"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onOptionDetailAuctionBatchHistory(
                        _vm.auctionBatch
                      )
                    }
                  }
                },
                [_c("feather-icon", { attrs: { icon: "SearchIcon" } })],
                1
              )
            ],
            1
          ),
          _vm._t(
            "action-list",
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Desplegar acciones",
                      expression: "'Desplegar acciones'"
                    }
                  ]
                },
                [
                  _c(
                    "b-dropdown",
                    {
                      directives: [
                        {
                          name: "has-permission",
                          rawName: "v-has-permission",
                          value: "ED185",
                          expression: "'ED185'"
                        }
                      ],
                      attrs: { variant: "link", "no-caret": "", right: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "button-content",
                          fn: function() {
                            return [
                              _c("feather-icon", {
                                staticClass: "align-middle text-body",
                                attrs: {
                                  "data-cy": "gear-button",
                                  width: "24px",
                                  height: "24px",
                                  icon: "SettingsIcon"
                                }
                              })
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED166" } },
                        [
                          _c(
                            "b-dropdown-item",
                            {
                              attrs: { "data-cy": "binnacle" },
                              on: {
                                click: function($event) {
                                  return _vm.onOptionAuctionBatchHistoryBinnacle(
                                    _vm.auctionBatch
                                  )
                                }
                              }
                            },
                            [
                              _c("vs-icon", { attrs: { icon: "list" } }),
                              _vm._v(" Bitácora ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            { auctionBatch: _vm.auctionBatch }
          )
        ],
        2
      ),
      _c(
        "b-modal",
        {
          ref: "batch-detail-" + _vm.auctionBatch.loteId,
          attrs: {
            id: "batch-detail-" + _vm.auctionBatch.loteId,
            title: "Detalles del Lote Nº " + _vm.auctionBatch.folio,
            "no-close-on-backdrop": "",
            size: "lg",
            "hide-footer": ""
          }
        },
        [_c("BatchDetail", { attrs: { batch: _vm.auctionBatch } })],
        1
      ),
      _c("ModalBinnacle", {
        ref: "binnacle-" + _vm.auctionBatch.loteId,
        attrs: {
          batch: _vm.auctionBatch,
          title: "Bitácora del Lote Nº " + _vm.auctionBatch.folio,
          id: "binnacle-" + _vm.auctionBatch.loteId
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }